import React, { Component } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { connect } from "react-redux";
import _ from "lodash";

// Components
import Subheader from 'material-ui/Subheader';
import FlatButton from 'material-ui/FlatButton';

// Instruments
import { categoriesOriginal } from '../../fixtures/categories';
import { getImagePreviewUrl, FileStackClient } from '../../services/FileStackService';

import { getFilesByProjectId } from "../../redux/files/actions";
import { setProjectId } from "../../redux/checklists/actions";
import { getProject } from '../../redux/projects/actions';
import { getProjectLocations } from '../../redux/locations/actions';
import { getUserProjects, updateProjectLogo } from "../../redux/projects/actions";

// Selectors
import * as selectors from "../../redux/projects/selectors";
import * as authSelectors from "../../redux/auth/selectors";
import * as checklistSelectors from "../../redux/checklists/selectors";
import * as fileSelectors from "../../redux/files/selectors";

// Styles & assets
import "../../styles/GridList.css";
import defaultProjectImage from '../../assets/default-project.jpg';

const mapStateToProps = (state) => ({
  userId: authSelectors.getUserId(state),
  projectsList: selectors.projectsList(state),
  projectFiles: fileSelectors.projectFiles(state),
  project: selectors.projectDetails(state),
  filter: fileSelectors.getFilter(state),
  searchEnabled: fileSelectors.fileSearchEnabled(state),
  filesSearchList: fileSelectors.fileSearchList(state),
  projectFetched: selectors.projectIsFetched(state),
  projectIsFetching: selectors.projectIsFetching(state),
  checklistProjectId: checklistSelectors.checklistProjectId(state),
});

const mapDispatchToProps = {
  getUserProjects,
  getFilesByProjectId,
  setProjectId,
  getProject,
  getProjectLocations,
  updateProjectLogo
};

class Settings extends Component {
  state = {};

  componentDidMount() {
    const { history, track, getProjectLocations } = this.props;
    const {location} = history;
    const {projectId} = this.props.match.params;
    const { userId } = JSON.parse(localStorage.getItem("auth0")) || "";

    // history.push(`settings/`);
    this.props.getUserProjects(userId);

    if (!this.componentHasData()) {
      this.componentUpdateData();
    }

    if (location.state && location.state.action === 'upload') {
      track('Web app: Redirected from email link');

      this._handleUpload();
    }

    getProjectLocations(projectId);
  }

  componentWillReceiveProps(nextProps) {

    if (!this.componentHasData()) {
      this.componentUpdateData(nextProps);
    }

    if (nextProps.checklistProjectId !== this.props.checklistProjectId) {

      this.props.getFilesByProjectId(nextProps.checklistProjectId);
      this.props.getProject(nextProps.checklistProjectId);
    }

    if (Object.keys(nextProps.projectsList).length !== Object.keys(this.props.projectsList).length) {
      const firstProjectId = Object.values(nextProps.projectsList)[0].id;

      const { setProjectId } = this.props;
      setProjectId(firstProjectId);
    }
  }

  componentHasData(props = this.props) {
    const { project, projectFiles} = this.props;

    if (!project) {
      return false;
    }

    return Object.keys(project).length > 0 && projectFiles !== false;
  }

  componentUpdateData(props = this.props) {
    const { project, projectFiles, checklistProjectId } = props;
    if (checklistProjectId) {
      const projectId = checklistProjectId;

      if (projectId === 'PRIVATE') {
        return;
      }

      if ((props.checklistProjectId !== this.props.checklistProjectId) || !Object.keys(project).length ) {
        this.props.getProject(projectId);
      }

      if (projectFiles !== null && !projectFiles && !Object.keys(projectFiles).length) {
        this.props.getFilesByProjectId(projectId);
      }

      if (projectFiles && Object.keys(projectFiles).length) {
        this.prepareCategories(projectFiles);
        this.prepareLocations(projectFiles);
      }
    }
  }

  prepareLocations(files) {
    const locationsObj = {
      general: {
        location: {
          id: 'General',
          title: 'General',
          symbol: 'GN'
        },
        files: []
      }
    }

    Object.values(files).forEach(file => {
      if (!file.location) {
        return locationsObj.general.files.push(file);
      }

      if (locationsObj[file.location.name]) {
        locationsObj[file.location.name].files.push(file)
      } else {
        locationsObj[file.location.name] = {
          location: {
            id: file.location.id,
            title: file.location.name,
            symbol: file.location.name.slice(0, 2).toUpperCase()
          },
          files: [file]
        }
      }
    })

    this.setState({ filesByLocations: Object.values(locationsObj) })
  }

  prepareCategories(files) {
    let dataForAlbum = {};
    Object.keys(files).map((fileId) => {
      const file = files[fileId];
      if (file.categories) {
        file.categories.map((categoryId) => {

          if (!dataForAlbum[categoryId]) {
            dataForAlbum[categoryId] = {category: categoriesOriginal[categoryId], files: []};
          }

          dataForAlbum[categoryId].files.push(file);
        });
      } else {
        if (!dataForAlbum["noCategory"]) {
          dataForAlbum["noCategory"] = {
            category: {
              id: "noCategory",
              title: 'No categories',
              symbol: "NC"
            },
            files: []
          };
        }

        dataForAlbum["noCategory"].files.push(file);
      }
    });
    dataForAlbum = _.sortBy(dataForAlbum, (item) => {
      return item.files.length;
    }).reverse();

    this.setState({
      album: dataForAlbum
    })
  }


  _handleLogoUpload = () => {
    FileStackClient.picker({
      maxFiles: 1,
      fromSources: [
        "local_file_system",
        "googledrive",
        "dropbox",
        "gmail",
        "box",
        "onedrive",
        "clouddrive"
      ],
      onUploadDone: (res) => {
        this.props.updateProjectLogo({projectId: this.props.checklistProjectId, file: res.filesUploaded[0]});
      }
    }).open();
  };

  render() {
    const { project } = this.props;

    if (!project) {
      return null;
    }

    const previewImageStyles = {
      backgroundImage: `url(${typeof project.images !== 'undefined' ? getImagePreviewUrl(project.images.main, 300, 300) : defaultProjectImage})`
    };

    return (
      <div className="dashboard-page-wrap">
        <Grid className="dashboard-page dashboard-page-small">
        {Object.keys(project).length > 0 &&
              <Row>
                <Col xs={12}>
                  <Subheader className="subheader project-details-subheader">
                    <span>Project</span>
                  </Subheader>
                  <div className="project-details">
                    <div className="image">
                      <div style={previewImageStyles}/>
                    </div>
                    <div className="details">
                      <div className="title">{project.title}</div>
                      <div className="address">{project.address}</div>
                      <div style={{marginTop: '25px'}}>
                        <FlatButton
                          backgroundColor="#6da92e"
                          hoverColor="#83BA2C"
                          labelStyle={{color: '#fff'}}
                          fullWidth
                          label="Upload Logo"
                          onClick={this._handleLogoUpload}
                        />
                      </div>
                    </div>
                    <div className="details-logo">
                      {project.companyLogo &&
                        <div className="image" style={{marginLeft: '15px'}}>
                          <div style={{backgroundImage: `url(${project.companyLogo})`}}/>
                        </div>
                      }
                    </div>
                  </div>
                </Col>
              </Row>
              }
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
